// extracted by mini-css-extract-plugin
module.exports = {"MigrationNotice":"MigrationNotice_MigrationNotice__yyehl","MigrationNoticeContent":"MigrationNotice_MigrationNoticeContent__FQjC4"};